import Cookies from "js-cookie";
import { safeLocalStorage, safeCall } from "./safeStorage";

// In-memory fallback so a session survives even when the browser blocks
// BOTH localStorage and cookies for this tab (Safari "Block All Cookies",
// locked-down enterprise browsers, some in-app WebViews). Lost on a full
// reload in that case, but an order already in progress can still complete
// instead of hard-failing with no error anywhere.
let memoryToken;

// Session token can live in localStorage, the user_session cookie, or (as
// a last resort) memory. Always check in this order, and this is the ONLY
// place that should be checked — axios.js and ProtectedRoute both call
// this so "is the user logged in" never disagrees with "will authenticated
// API calls work".
export const getSessionToken = () => {
  let token = safeLocalStorage.getItem("user_session");
  if (!token) {
    token = safeCall(() => Cookies.get("user_session"), undefined);
  }
  if (!token) {
    token = memoryToken;
  }
  if (token) {
    memoryToken = token;
  }
  return token || undefined;
};

export const setSessionToken = (token) => {
  memoryToken = token;
  safeLocalStorage.setItem("user_session", token);
  safeCall(() => Cookies.set("user_session", token), undefined);
};

export const clearSessionToken = () => {
  memoryToken = undefined;
  safeLocalStorage.removeItem("user_session");
  safeCall(() => Cookies.remove("user_session"), undefined);
};

export const isLoggedIn = () => !!getSessionToken();
